export default "__VITE_ASSET__CUEk1Rfv__"